import { Box } from '@frontierag/frontier-ui-library';
import { useWizardData, VPAccordion } from 'components';
import DataAccordionColumns from 'components/DataAccordionColumns';
import DataColumns from 'components/DataColumns';
import useOrderDetailsCrop from 'hooks/useOrderDetailsCrop';
import useOrderDetailsFieldsCrop from 'hooks/useOrderDetailsFieldsCrop';
import { CROP_VIRTUAL_PRODUCT_TYPE } from 'appConstants';
import type { IPackProduct } from 'contexts/CropOrders/types';

export default function OrderSummary() {
  const { values } = useWizardData();

  const fieldsSchema = useOrderDetailsCrop('CreateCropOrder', true);
  const orderDetailsFields = useOrderDetailsFieldsCrop('CreateCropOrder', true);

  return (
    <Box data-testid="crop-order-summary-page">
      {values.products.map((product) => (
        <Box pb={2} key={`accordion-${product.packagedItemReference}`}>
          <DataAccordionColumns
            fieldsSchema={fieldsSchema}
            data={product}
            title={product.productData?.packagedItemDescription}
            key={product.packagedItemReference}
            name={`product-${product.packagedItemReference}`}
            defaultExpanded={true}
          >
            {product.productType === CROP_VIRTUAL_PRODUCT_TYPE &&
              product.productData?.packProducts?.map((packProduct: IPackProduct, index: number) => (
                <VPAccordion
                  key={`virtual-pack-${packProduct.packagedItemReference}`}
                  transNamespace="CreateCropOrder"
                  packProduct={{
                    ...packProduct,
                    packagedItemQty: product.packagedItemQty * packProduct.ratio,
                  }}
                  productIndex={index + 1}
                />
              ))}
          </DataAccordionColumns>
        </Box>
      ))}
      <Box pb={{ xs: 2, sm: 3 }} pt={1}>
        <DataColumns data={values} columnsSchema={orderDetailsFields} />
      </Box>
    </Box>
  );
}
